<script>
	import { appProfileState } from "../../state/ApplicationState.svelte";
	import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";
	import { FormGroup, Input, Alert, Icon, Button } from "@sveltestrap/sveltestrap";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import Dialog from "../../../../../SharedSvelte//Dialog.svelte";

	let prompt;

    let saveError = $state("");

    function clearAllErrors() {
		saveError = "";
	}
	
	function resetMfa() {
		// Returns a Promise<string> that resolves with urlFromJSON
		return new Promise((resolve, reject) => {
			Loader.display();
			
			const headers = {
				"Content-Type": "application/json",
				__RequestVerificationToken: document.getElementsByName("__RequestVerificationToken")[0]?.value,
			};

			fetch(`${baseUrl}Security/ResetMfaEnrollment`, {
				method: "POST",
				headers,
			})
			.then(response => {
				if (!response.ok) {
					const msg = `Server exception: ${response.status} ${response.statusText}`;
					console.error(msg);
					throw new Error(msg);
				}
				return response.json();
			})
			.then(json => {
				const urlFromJSON = json?.url;

				if (typeof urlFromJSON === "string" && urlFromJSON.startsWith("https://")) {
					// Resolve with the URL so the caller can use it
					resolve(urlFromJSON);
				} else {
					const msg = "Invalid or missing URL in JSON response.";
					console.error(msg);
					throw new Error(msg);
				}
			})
			.catch(err => {
				reject(err);
			})
			.finally(() => {
				Loader.hide();
			});
		});
	}


    function handleSubmit(event) {
        event.preventDefault();
		const newTab = window.open('about:blank', '_blank');
				
		resetMfa()
			.then(url => {
				appProfileState.securityEnrolledMfa = [];
				clearAllErrors();

				if (newTab) {
					newTab.location.href = url;
					newTab.focus();
				} /*else {
					// Optional: handle popup block
					console.error("Pop-up blocked! Please allow pop-ups for this site.");
				}*/
			})
			.catch(err => {
				console.error("Reset MFA failed:", err);
				saveError = "Failed to reset MFA Enrollment. ";
				newTab.close();
				//if (err?.message) saveError += err.message;
			});

    }
</script>

<main class="mt-5 mb-2">
    <div class="card shadow" style="max-width: 600px;">
        <div class="card-body">
            <h3 class="card-title text-center mb-4">Multi-Factor Authentication</h3>
			<p>Current Multi-Factor Authentication Enrollment</p>
			<ul>
			{#each appProfileState.securityEnrolledMfa as mfaItem}
				<li>{mfaItem}</li>
			{/each}
			</ul>
			<p>To change the MFA Enrollment, MFA must be reset.</p>
            <form onsubmit={handleSubmit}>
                {#if saveError}
					<div class="alert alert-danger p-2">{saveError}</div>
				{/if}
				<div class="button-group mt-3">
					<button type="submit" class="btn btn-danger w-100">Reset Multi-Factor Authentication</button>
				</div>
            </form>
        </div>
    </div>
</main>

<Dialog bind:this={prompt} />
